import { createContext, useContext } from "react";
import { SubscriptionPlanFunctionality } from "@iventis/domain-model/model/subscriptionPlanFunctionality";
import { AnalysisType } from "@iventis/domain-model/model/analysisType";

interface FunctionalityContextInterface extends SubscriptionPlanFunctionality {
    open?: (type: keyof SubscriptionPlanFunctionality) => void;
}

export const FunctionalityContext = createContext<FunctionalityContextInterface>({
    sharedLinks: false,
    customSharedLinkExpiry: false,
    sharedWorkspace: false,
    iconAndModelUploads: false,
    layerCopying: false,
    plansCopying: false,
    importingLayers: false,
    pdfExports: false,
    layer3DTypes: false,
    customLogo: false,
    siteMaps: false,
    customLayer: false,
    sso: false,
    analysisTypes: [],
    attributeDataExport: false,
    listItemProperties: false,
    digitalTwin: false,
    unlinkingLayers: false,
    imagesOnModels: false,
    customColourOnModels: false,
    mapObjectDwgExport: false,
    mapObjectKmlExport: false,
    changeLog: false,
    projectTemplates: false,
    plansPerCopyLimit: 25,
    layersPerCopyLimit: 100,
    layersPerImportLimit: 100,
    mapObjectCreateLimit: 20000,
    layersPerPlanLimit: 600,
    mapObjectsPerCopyLimit: 5000,
    mapObjectsPerLayerLimit: 30000,
} as FunctionalityContextInterface);

export const allFunctionality = {
    sharedLinks: true,
    customSharedLinkExpiry: true,
    sharedWorkspace: true,
    iconAndModelUploads: true,
    layerCopying: true,
    plansCopying: true,
    importingLayers: true,
    pdfExports: true,
    layer3DTypes: true,
    customLogo: true,
    siteMaps: true,
    customLayer: true,
    sso: true,
    analysisTypes: Object.values(AnalysisType),
    attributeDataExport: true,
    listItemProperties: true,
    digitalTwin: true,
    unlinkingLayers: true,
    imagesOnModels: true,
    customColourOnModels: true,
    mapObjectDwgExport: true,
    mapObjectKmlExport: true,
    changeLog: true,
    projectTemplates: true,
    plansPerCopyLimit: 25,
    layersPerCopyLimit: 100,
    layersPerImportLimit: 100,
    mapObjectCreateLimit: 20000,
    layersPerPlanLimit: 600,
    mapObjectsPerCopyLimit: 5000,
    mapObjectsPerLayerLimit: 30000,
} as FunctionalityContextInterface;

export const useFunctionality = () => useContext(FunctionalityContext);
